import React from 'react'
import {connect} from 'react-redux'
import {modelsFromObject} from '../../helpers/models-from-object.js'
import SubmissionMenuOption from './SubmissionMenuOption'

class SubmissionHomeMenu extends React.Component {

  handleClick(model) {
    //This is passed down and back up through MockActionLink
    this.props.arenaMenuSnapshot.submit(model);
  }

  handleHover(model) {
    //This is passed down and back up through MockActionLink
    this.props.arenaMenuSnapshot.setActive(model);
  }

  render() {

    const arenaMenuSnapshot = this.props.arenaMenuSnapshot;
    return (
      <div>
        {
          modelsFromObject(arenaMenuSnapshot.optionsData).map((option, i) => {
            return (
              <SubmissionMenuOption
                key={i}
                model={option}
                handleClick={this.handleClick.bind(this)}
                handleHover={this.handleHover.bind(this)}
                vW={this.props.vW}
                isTouchMode={this.props.isTouchMode}
              />
            )
          })
        }
      </div>
    );
  }
}
export default connect((state, props) => {
  return {
    isTouchMode: state.global.isTouchMode,
    arenaMenuSnapshot: state.battle.arenaMenuSnapshot,
    vW: state.global.vW
  }
})(SubmissionHomeMenu)



// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionHomeMenu.js